/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-debugger */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-case-declarations */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React, {
    useState, useEffect, useCallback, useContext,
} from 'react';
import SlidingPane from 'react-sliding-pane';
import { connect } from 'react-redux';
import { ThreeDots } from 'react-loader-spinner';
import { motion, AnimatePresence } from 'framer-motion';
import { DistributorActions } from '../../redux/actions';
import TableHeader from '../../TableHeader';
import ListDistributors from './ListDistributors';
import Pagination from '../../Components/Pagination';
import ItemSkeleton from '../../Components/Skeletons/itemSkeleton';
import HeaderContext from '../../Components/Context/HeaderContext';
import DistributorHeaderSkeleton from '../../Components/Skeletons/DistributorHeader';
import { distributorService } from '../../service/distributor.service';
import FilterModal from './FilterModal';
import UserListingHeaderSkeleton from '../../Components/Skeletons/UserListingHeaderSkeleton';
import EmptyScreen from '../ManageOffers/EmptyScreen';
import CustomToast from '../../Components/AlertPopup';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

function DistributorManagement({ DistributorList, GetDistributorList, SortDistributor }) {
    const [searchValue, setsearchValue] = useState('');
    const [isLoaded, setisLoaded] = useState(false);
    const [currentPage, setcurrentPage] = useState(1);
    const [nextPageHasData, setnextPageHasData] = useState(false);
    const [status, setstatus] = useState('all');
    const [sortType, setsortType] = useState('');
    const [sort, setsort] = useState(false);
    const [filter, setfilter] = useState(false);
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [isEditId, setisEditId] = useState('');
    const [filterValue, setfilterValue] = useState('');
    const [color, setcolor] = useState(false);
    const [OpenPopup, setOpenPopup] = useState('');
    const [actvloader, setactvloader] = useState(false);
    const [showPopup, setshowPopup] = useState(false);
    const [title, settitle] = useState(' OTP Verification Successful!');
    const [exportIndicatorLoading, setExportIndicatorLoading] = useState(false);

    const [selected, setselected] = useState({
        type: [],
        status: '',
    });
    const viewprevilegeassigned = AccessPrevilegesFunction('distributor:view');
    const updateprevilegeassigned = AccessPrevilegesFunction('distributor:update' || 'distributor:assignment' || 'distributor:upload_certificate');

    const {
        HardRefresh,
        setHardRefresh,
    } = useContext(HeaderContext);
    const handleFetch = useCallback((() => {
        GetDistributorList(currentPage, searchValue, filterValue, sortType).then((val) => {
            if (val.data.success_status) {
                setHardRefresh(false);
                setfilter(false);
                setisLoaded(true);
            }
        });
    }), [currentPage, searchValue, filterValue, sortType]);

    const handleFiletr = (url) => {
        if (url.length > 0 && filterValue !== url) {
            setisLoaded(true);
            setcurrentPage(1);
            setfilterValue(url);
        } else {
            setfilter(false);
            setfilterValue(url);
        }
    };
    useEffect(() => {
        handleFetch();
    }, [handleFetch]);
    const variants = {
        open: { opacity: 1, x: 0 },
        closed: { opacity: 1, x: '-10px' },
    };
    function compare(a, b) {
        if (a.first_name < b.first_name) {
            return -1;
        }
        if (b.first_name > a.first_name) {
            return 1;
        }
        return 0;
    }
    function comparelast(a, b) {
        if (a.last_name < b.last_name) {
            return -1;
        }
        if (a.last_name > b.last_name) {
            return 1;
        }
        return 0;
    }
    function compareName(a, b) {
        if (a.PARTY_NAME < b.PARTY_NAME) {
            return -1;
        }
        if (a.PARTY_NAME > b.PARTY_NAME) {
            return 1;
        }
        return 0;
    }
    function compareStatus(a, b) {
        if (a.admin_status < b.admin_status) {
            return -1;
        }
        if (a.admin_status > b.admin_status) {
            return 1;
        }
        return 0;
    }
    const handleSort = useCallback((type) => {
        let data;
        if (DistributorList.distributors) {
            const userListdata = DistributorList.distributors;

            switch (type) {
            case 'first_name':
                const data1 = userListdata && userListdata.sort(compare);
                if (sortType === 'first_name') {
                    SortDistributor(data1.reverse());
                } else {
                    SortDistributor(data);
                }
                break;
            case 'last_name':
                const data2 = userListdata && userListdata.sort(comparelast);
                if (sortType === 'last_name') {
                    SortDistributor(data2.reverse());
                } else {
                    SortDistributor(data2);
                } break;
            case 'company_name':
                const data3 = userListdata && userListdata.sort(compareName);
                if (sortType === 'company_name') {
                    SortDistributor(data3.reverse());
                } else {
                    SortDistributor(data3);
                } break;
            case 'status':
                const data4 = userListdata && userListdata.sort(compareStatus);
                if (sortType === 'status') {
                    SortDistributor(data4.reverse());
                } else {
                    SortDistributor(data4);
                } break;
            default: break;
            }
        }
    }, [sortType, DistributorList]);
    const handlePageClick = async (data) => {
        setisLoaded(false);
        const page = data.selected + 1;
        setcurrentPage(page);
    };
    const handleExport = useCallback((() => {
        distributorService.handleDisributorExport(currentPage, searchValue, filterValue, sortType, exportSelected).then((val) => {
            if (val.data.success_status) {
                setshowPopup(true);
                settitle(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    settitle('');
                    setshowPopup(false);
                }, 3000);
            }
        });
    }), [exportSelected]);
    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const handleActivateOrDeactivate = (status1, accountID) => {
        setactvloader(true);
        const payload = {
            STATUS: String(status1),
        };
        distributorService.offerActiveOrDeactivateDistributor(payload, accountID).then((res) => {
            if (!res.error && res.data.success_status === false) {
                settitle(res.data.message);
                setshowPopup(true);
                setOpenPopup('');
                setactvloader(false);
                setisLoaded(false);
                setTimeout(() => {
                    setshowPopup(false);
                }, 4000);
                handleFetch();
            } else {
                setactvloader(false);
            }
        });
    };

    function OtpSuccessMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                {title}
            </p>
        );
    }

    const handleExportLoadingIndicator = () => {
        setExportIndicatorLoading(true);
        setTimeout(() => {
            setExportIndicatorLoading(false);
        }, 2000);
    };

    return (
        <div>
            {
                showPopup && (
                    <CustomToast
                        open
                        color={color ? '#ED1C24' : undefined}
                        message={<OtpSuccessMeessage />}
                    />
                )
            }
            <div className="sticky top-[92px] bg-[#ffffff] z-[99]">

                {!HardRefresh ? (
                    <motion.div
                        animate={{ opacity: 1, x: 0 }}
                        initial={{ opacity: 0, x: -10 }}
                        exit={{ opacity: 0, x: -10 }}
                        transition={{ duration: 0.15 }}
                        style={{ zIndex: '99', position: 'sticky' }}
                    >
                        <div className="flex justify-between pt-[25px]" style={{ paddingBottom: '18px' }}>
                            <h5 className="text-xs4 font-semibold text-[#090406]">Distributors/Customer</h5>
                            <div className="flex">
                                <div className="relative">
                                    <label htmlFor="search" />
                                    <input
                                        type="text"
                                        onChange={(e) => {
                                            setsearchValue((e.target.value).trim());
                                            if (e.target.value !== '') {
                                                setcurrentPage(1);
                                            }
                                        }}
                                        name="search"
                                        id="search"
                                        className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                                        placeholder="Search"
                                    />
                                    <img src="images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" />
                                </div>
                                <div className="pl-2 dropdown relative">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setisEditId('');
                                            setfilter(!filter);
                                        }}
                                        id="exportDropdown"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] px-9 border border-[#555259] rounded-lg"
                                    >
                                        Filter
                                    </button>

                                </div>
                                <div className="pl-2 dropdown relative">
                                    <button
                                        type="button"
                                        disabled={DistributorList?.distributors?.length === 0}
                                        onClick={() => {
                                            setisEditId('');
                                            setexportClick(!exportClick);
                                        }}
                                        id="exportDropdown"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] px-9 border border-[#555259] rounded-lg"
                                    >
                                        {exportIndicatorLoading ? <ThreeDots width={30} height={24} /> : 'Export'}
                                    </button>
                                    <motion.ul
                                        initial={false}
                                        style={{ zIndex: '99' }}
                                        animate={exportClick ? 'open' : 'closed'}
                                        className={`dropdown-menu min-w-[110px] absolute 
                         ${exportClick ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2`}
                                        aria-labelledby="exportDropdown"
                                    >
                                        <li
                                            className="px-5 pb-1.5 pt-5"
                                        >
                                            <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => { setexportSelected('export-csv'); handleExportLoadingIndicator(); }}>CSV</a>
                                        </li>
                                        <li className="px-5 py-1.5">
                                            <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => { setexportSelected('/pdf-converter/html-to-pdf'); handleExportLoadingIndicator(); }}>PDF</a>
                                        </li>
                                        <li className="px-5 pt-1.5 pb-5">
                                            <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="javascript:void(0)" onClick={() => { setexportSelected('export-excel'); handleExportLoadingIndicator(); }}>Excel</a>
                                        </li>
                                    </motion.ul>
                                </div>
                            </div>
                        </div>

                    </motion.div>
                ) : <UserListingHeaderSkeleton />}
                <div
                    className="overflow-auto dropdown-menu sticky top-0"
                    style={{
                        zIndex: `${filter ? '0' : '50'}`,
                        height: 'calc(100vh - 298px)',
                    }}
                >
                    {isLoaded
                        ? (
                            <>
                                {DistributorList.distributors.length > 0 ? (
                                    <table className="w-full table-auto relative">
                                        <AnimatePresence>

                                            <motion.thead
                                                animate={{ opacity: 1, x: 0 }}
                                                initial={{ opacity: 0, x: -10 }}
                                                exit={{ opacity: 0, x: -10 }}
                                                transition={{ duration: 0.15 }}
                                                style={{ zIndex: exportClick ? '0' : '99' }}
                                                className="sticky top-0"
                                            >
                                                <tr className="bg-[#555259] h-10">
                                                    <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[158px] bg-[#555259]" scope="col">
                                                        <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                            Customer Code
                                                        </span>
                                                    </th>
                                                    <th className="py-2.5 px-7 min-w-[140px" scope="col">
                                                        <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                            Type
                                                        </span>
                                                    </th>
                                                    <th scope="col" className="py-2.5 px-7 min-w-[180px]" style={{ minWidth: '15    0px' }}>
                                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                            First Name
                                                            <a href="javascript:void(0)" className="pl-[5px]">
                                                                <img
                                                                    src="images/sort.svg"
                                                                    className={`${sortType === 'FIRST_NAME+asc' ? 'image-rotate' : ''}`}
                                                                    alt="icon"
                                                                    onClick={() => {
                                                                        if (sortType === 'FIRST_NAME+asc') {
                                                                            setsortType('FIRST_NAME+desc');
                                                                        } else if (sortType === 'FIRST_NAME+desc') {
                                                                            setsortType('FIRST_NAME+asc');
                                                                        } else { setsortType('FIRST_NAME+asc'); }
                                                                    }}
                                                                />
                                                            </a>
                                                        </span>
                                                    </th>
                                                    <th scope="col" className="py-2.5 px-7 min-w-[180px]" style={{ minWidth: '150px' }}>
                                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                            Last Name
                                                            <a href="javascript:void(0)" className="pl-[5px]">
                                                                <img
                                                                    src="images/sort.svg"
                                                                    className={`${sortType === 'LAST_NAME+asc' ? 'image-rotate' : ''}`}
                                                                    alt="icon"
                                                                    onClick={() => {
                                                                        if (sortType === 'LAST_NAME+asc') {
                                                                            setsortType('LAST_NAME+desc');
                                                                        } else if (sortType === 'LAST_NAME+desc') {
                                                                            setsortType('LAST_NAME+asc');
                                                                        } else { setsortType('LAST_NAME+asc'); }
                                                                    }}
                                                                />
                                                            </a>
                                                        </span>
                                                    </th>
                                                    <th scope="col" className="py-2.5 px-7 min-w-[180px]" style={{ minWidth: '260px' }}>
                                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                            Company Name
                                                            <a href="javascript:void(0)" className="pl-[5px]">
                                                                <img
                                                                    src="images/sort.svg"
                                                                    className={`${sortType === 'PARTY_NAME+asc' ? 'image-rotate' : ''}`}
                                                                    alt="icon"
                                                                    onClick={() => {
                                                                        if (sortType === 'PARTY_NAME+asc') {
                                                                            setsortType('PARTY_NAME+desc');
                                                                        } else if (sortType === 'PARTY_NAME+desc') {
                                                                            setsortType('PARTY_NAME+asc');
                                                                        } else { setsortType('PARTY_NAME+asc'); }
                                                                    }}
                                                                />
                                                            </a>
                                                        </span>
                                                    </th>
                                                    <th scope="col" className="py-2.5 px-7 min-w-[140px]">
                                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                            Status
                                                        </span>
                                                    </th>
                                                    <th scope="col" className="py-2.5 px-7 min-w-[220px] text-left whitespace-nowrap">
                                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                            Falcon Login Status
                                                            <a href="javascript:void(0)" className="pl-[5px]">
                                                                <img
                                                                    src="images/sort.svg"
                                                                    className={`${sortType === 'FALCON_LOGIN_STATUS+asc' ? 'image-rotate' : ''}`}
                                                                    alt="icon"
                                                                    onClick={() => {
                                                                        handleSort('status');
                                                                        if (sortType === 'FALCON_LOGIN_STATUS+asc') {
                                                                            setsortType('FALCON_LOGIN_STATUS+desc');
                                                                        } else {
                                                                            setsortType('FALCON_LOGIN_STATUS+asc');
                                                                        }
                                                                        setTimeout(() => {
                                                                            setsort(!sort);
                                                                        }, 1000);
                                                                    }}
                                                                />
                                                            </a>
                                                        </span>
                                                    </th>
                                                    <th scope="col" className="py-2.5 px-7 min-w-[180px]">
                                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                            Email Address
                                                        </span>
                                                    </th>
                                                    <th scope="col" className="py-2.5 px-7 min-w-[166px]">
                                                        <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                            Mobile Number
                                                        </span>
                                                    </th>
                                                    <th scope="col" className="py-2.5 px-7 rounded-tr-lg rounded-br-lg min-w-[100px] bg-[#555259]" />
                                                </tr>
                                            </motion.thead>
                                        </AnimatePresence>
                                        <>
                                            {
                                                DistributorList.distributors.length > 0
                                                    ? (
                                                        <ListDistributors
                                                            list={DistributorList.distributors}
                                                            handleActivateOrDeactivate={handleActivateOrDeactivate}
                                                            OpenPopup={OpenPopup}
                                                            setOpenPopup={setOpenPopup}
                                                            actvloader={actvloader}
                                                            setactvloader={setactvloader}
                                                            isEditId={isEditId}
                                                            setisEditId={setisEditId}
                                                            viewprevilegeassigned={viewprevilegeassigned}
                                                            updateprevilegeassigned={updateprevilegeassigned}
                                                        />
                                                    ) : (
                                                        <div className="flex items-center justify-center">
                                                            <h1 style={{ position: 'absolute', right: '50%', top: '100%' }}>No distributor data found !!</h1>
                                                        </div>
                                                    )
                                            }
                                        </>
                                    </table>
                                ) : <EmptyScreen title="No distributor data found !!" />}
                                <SlidingPane
                                    from="right"
                                    isOpen={filter}
                                    width="30%"
                                    className="z-60"
                                    hideHeader
                                    onRequestClose={() => setfilter(false)}

                                >
                                    <FilterModal
                                        filter={filter}
                                        setfilter={setfilter}
                                        handleFiletr={handleFiletr}
                                        selected={selected}
                                        setselected={setselected}
                                    />

                                </SlidingPane>
                            </>
                        ) : <ItemSkeleton headerHeight="35px" />}

                </div>
            </div>
            {DistributorList.pagination > 1 && (
                <Pagination handlePageClick={handlePageClick} List={DistributorList} currentPage={currentPage} />
            )}
        </div>
    );
}
const mapState = (state) => {
    const { DistributorList, AdminUserPagination } = state;
    return { DistributorList, AdminUserPagination };
};
const createActors = {
    GetDistributorList: DistributorActions.DistributorList,
    SortDistributor: DistributorActions.SortDistributor,
    handlePagination: DistributorActions.AdminPaginationMethod,
};
const connectDistributorManagement = connect(mapState, createActors)(DistributorManagement);

export { connectDistributorManagement as DistributorManagement };
